import { useTranslation } from "react-i18next";
import "./dynamic-card.scss";
import { useState } from "react";

export const useDynamicCard = ({
  enableTMModal = false,
  action,
}: {
  enableTMModal: boolean;
  action: () => void;
}) => {
  const { t } = useTranslation();

  const [showTMModal, setShowTMModal] = useState(false);

  const onConfirmTMModal = () => {
    setShowTMModal(false);
    action();
  };

  const onPressCardActionButton = () =>
    enableTMModal ? setShowTMModal(true) : action();

  return {
    t,
    showTMModal,
    setShowTMModal,
    onConfirmTMModal,
    onPressCardActionButton,
  };
};
